import { BrowserRouter } from 'react-router-dom'
import { MsalProvider } from '@azure/msal-react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { IPublicClientApplication } from '@azure/msal-browser'

import { ErrorBoundary } from './router/ErrorBoundary'
import { ThemeProvider } from './theme'
import { ModalProvider } from './components/Modal'
import { Router } from './router'
import { NotificationProvider } from '@/ui/Notification'
import { useInitApp } from './helpers/useInitApp'

import { getAppInsights } from '@/helpers/telemetry/appInsights'
import { useGlobalErrorReporting } from './router/hooks/useGlobalErrorReporting'

getAppInsights()

const queryClient = new QueryClient()

type AppProps = {
    pca: IPublicClientApplication
}

export const App = ({ pca }: AppProps) => {
    useInitApp()
    useGlobalErrorReporting()

    return (
        <ErrorBoundary>
            <MsalProvider instance={pca}>
                <QueryClientProvider client={queryClient}>
                    <ThemeProvider>
                        <BrowserRouter
                            future={{
                                v7_startTransition: true,
                                v7_relativeSplatPath: true,
                            }}
                        >
                            <ModalProvider>
                                <Router />
                                <NotificationProvider />
                            </ModalProvider>
                        </BrowserRouter>
                    </ThemeProvider>
                </QueryClientProvider>
            </MsalProvider>
        </ErrorBoundary>
    )
}
